
import { Component, Vue } from 'vue-property-decorator'
import GoodsCard from '@/views/goodsManage/mall/shop/template/GoodsCard.vue'
import {
  BannerImgListDto,
  getBannerImgList,
  getShopGoodsList,
  isOptionalGoods,
  ShopGoodsListDto
} from '@/api/shoppingMall'
import { Action, Getter } from 'vuex-class'
import { getPartnerCompanyList } from '@/api/company'
import store from '@/store'

@Component({
  name: 'ShopHome',
  components: {GoodsCard}
})
export default class ShopHome extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string
  @Getter info: any // 用户信息
  @Action setProviderId!: (val: string) => void
  @Action setRootPath!: (val: string) => void
  title = '进入店铺'
  goodsList: ShopGoodsListDto[] = []
  bannerList: BannerImgListDto[] = []
  params = {
    pageIndex: 1,
    pageSize: 20,
    shopId: '',
    customerId: '' // 公司编号
  }
  refreshing = false
  loading = false
  finished = false

  fromPage = ''  // '1' 来源页面属于原生的产业圈

  activated () {
    if (window.sessionStorage.getItem('refresh') === '1') {
      window.sessionStorage.setItem('refresh', '0')
      this.init()
    }

    // 判断店铺模块是否是产业圈内部内容
    if(this.$store.state.app.rootPath as string === '/shopHome'){
      this.getPartnerCompanyList()
    }
  }

  created () {
    // 来源页面属于原生的产业圈
    if (this.$route.query.fromPage === '1') {
      this.setRootPath('/shopHome?fromPage=1&refreshToken=1')
      this.fromPage = '1'
      this.getPartnerCompanyList()
    }else if(this.$store.state.app.rootPath as string === '/shopHome'){
      this.fromPage = '1'
      this.getPartnerCompanyList()
    } else {
      this.title = this.$route.query.shopHomeTitle as string
      this.init()
    }
  }

  init () {
    this.params.customerId = this.companyId
    this.params.shopId = this.providerId
    this.getBannerList()
    this.getGoodsList()
  }

  getPartnerCompanyList () {
    let params = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      // partnerCompanyId:'62f315b5d5e8c81a7d7881e5'
    }
    getPartnerCompanyList(params).then(res => {
      this.title = res.data.companyList[0].companyName
      this.setProviderId(res.data.companyList[0].companyId)
      this.init()
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.init()
  }

  /**
   * 上拉加载更多
   * */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    getShopGoodsList(this.params).then((res) => {
      this.goodsList = this.goodsList.concat(res.data.records)
      this.loading = false
      if (this.goodsList.length >= res.data.totalRecords) {
        this.finished = true
      }
    }).catch(() => {
      this.loading = false
    })
  }

  /**
   * 获取广告图片列表
   */
  getBannerList () {
    getBannerImgList({companyId: this.providerId}).then((res) => {
      this.bannerList = res.data || []
    }).catch(() => { })
  }

  /**
   * 获取商品列表
   */
  getGoodsList () {
    getShopGoodsList(this.params).then((res) => {
      this.refreshing = false
      this.goodsList = res.data.records || []
      if (this.goodsList.length >= res.data.totalRecords) {
        this.finished = true
      } else {
        this.finished = false
      }
    }).catch(() => {
      this.refreshing = false
    })
  }

  reloadList () {
    this.params.pageIndex = 1
    this.getGoodsList()
  }

  toSearchHistory () {
    this.$router.push({
      path: '/searchHistory',
      query: {
        searchType: '2'
      }
    })
  }

  toClass () {
    this.$router.push('/goodsClass')
  }

  favorites () {
    this.$router.push('/favorites')
  }


  newArrivals () {
    this.$router.push('/newArrivals')
  }

  hotSale () {
    this.$router.push('/hotSale')
  }

  toScan () {
    this.$bridge.callHandler('toQRCodePage', {}, (res: string) => {
      console.log(res, '条形码')
      if (res) {
        this.$router.push({
          path: '/shopBarCodeGoods',
          query: {
            barcode: res
          }
        })
      }
    })
  }

  toDetail (id: string) {
    const params = {
      shopId: this.params.shopId,
      goodsId: id,
      customerId: this.params.customerId,
    }
    isOptionalGoods(params).then((res) => {
      if (res.data.isOptional) {
        this.$router.push({
          path: '/goodsDetail',
          query: {
            goodsId: id
          }
        })
      } else {
        this.$dialog.alert({
          message: '商品过期不存在'
        }).then(() => {
          this.$emit('reloadList')
        })
      }
    }).catch(() => {
    })
  }

}
